import { Breadcrumbs } from "components/breadcrumbs";
import { CreateOrganizationForm } from "./components";

export const CreateOrganization : React.FC = () => {
  return (
    <div className="wrapper">
      <Breadcrumbs customPageLabel="Create Organization" />
      <CreateOrganizationForm />
    </div>
  );
}